import { assetUrl } from "utils";
import cx from "classnames";

export const LiteratiLogoDark = ({ width, className }: any) => (
  <img
    className={cx("literati-logo", className)}
    src={assetUrl("/static/img/literati-dark.svg")}
    alt="literati-logo"
    height="25"
    width={width}
  />
);
LiteratiLogoDark.defaultProps = {
  width: "91.828",
};
export default LiteratiLogoDark;
